import { render, staticRenderFns } from "./resource-introduce.vue?vue&type=template&id=48de2a53&"
import script from "./resource-introduce.vue?vue&type=script&lang=js&"
export * from "./resource-introduce.vue?vue&type=script&lang=js&"
import style0 from "./resource-introduce.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports